// services/MangroDashboard.js

import axios from 'axios'

const BASE = '/api/dashboard/mangrove'

const MangroDashboardService = {
    getMangroDashboard: ({ year, region, district, commune, fkt, village }) =>
        axios
            .get(`${BASE}/dashboard`, { params: { year, region, district, commune, fkt, village } })
            .then((res) => res.data.data),
    getMangroPlantersCount: ({ year, region, district, commune, fkt, village }) =>
        axios
            .get(`${BASE}/planters/count`, { params: { year, region, district, commune, fkt, village } })
            .then((res) => res.data.data)
}

export default MangroDashboardService
